import {useState, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../../selectors/pages/cashout/bitcoin';
import {createBitcoinCashOutRequest, clearBitcoinCashout} from '../../../../reducers/app/actions';
import {useNavigate, useLocation} from 'react-router-dom';

import LoaderPage from '../../../components/loader_page';

import Enter from './enter';
import Confirm from './confirm';
import Alert from './alert';

export default () => {
    const {wallet, cashout_request, create_button, confirm_button} = useSelector(Selector),
          dispatch = useDispatch(),
          navigate = useNavigate(),
          location = useLocation();

    useEffect(() => {
        dispatch(clearBitcoinCashout());
    }, [location]);

    if(!cashout_request)
        return <Enter wallet={wallet} button={create_button} onNext={data => {
            if(create_button)
                return;

            dispatch(createBitcoinCashOutRequest(data, navigate));
        }} />

    if(cashout_request.status == "unconfirmed")
        return <Confirm cashout_request={cashout_request} button={confirm_button} />

    return <Alert cashout_request={cashout_request} />
}